import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody, CardHeader, Nav, NavItem, NavLink, TabContent } from 'reactstrap';
import Badge from './badge';
import ChecksTab from './checksTab';
import FollowupsTab from './followupsTab';
const TabsSection = ({
  activeTab,
  onTabChange,
  checksArray,
  followupsArray,
  unanalyzedFollowupsCount,
  content: _content = null,
  path: _path = '',
  formActions: _formActions = null,
  reduxEntity: _reduxEntity = '',
  pendingOperation: _pendingOperation = false,
  notificationActions: _notificationActions = null
}) => /*#__PURE__*/React.createElement(Card, {
  className: "mb-4 quality-agent__tabs-card"
}, /*#__PURE__*/React.createElement(CardHeader, {
  className: "quality-agent__tabs-header"
}, /*#__PURE__*/React.createElement(Nav, {
  tabs: true,
  className: "border-bottom-0"
}, /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavLink, {
  className: activeTab === 'checks' ? 'active quality-agent__tab-link' : 'quality-agent__tab-link',
  onClick: () => onTabChange('checks')
}, "Checks", /*#__PURE__*/React.createElement(Badge, {
  tag: "span",
  color: "secondary",
  pill: true,
  className: "quality-agent__tab-badge"
}, checksArray.length))), followupsArray.length > 0 && /*#__PURE__*/React.createElement(NavItem, null, /*#__PURE__*/React.createElement(NavLink, {
  className: activeTab === 'followups' ? 'active quality-agent__tab-link' : 'quality-agent__tab-link',
  onClick: () => onTabChange('followups')
}, "Suggested Followups", /*#__PURE__*/React.createElement(Badge, {
  tag: "span",
  color: "primary",
  pill: true,
  className: "quality-agent__tab-badge"
}, unanalyzedFollowupsCount))))), /*#__PURE__*/React.createElement(CardBody, {
  className: "p-0 quality-agent__tab-content-wrapper"
}, /*#__PURE__*/React.createElement(TabContent, {
  activeTab: activeTab
}, /*#__PURE__*/React.createElement(ChecksTab, {
  checksArray: checksArray
}), followupsArray.length > 0 && /*#__PURE__*/React.createElement(FollowupsTab, {
  followupsArray: followupsArray,
  content: _content,
  path: _path,
  formActions: _formActions,
  reduxEntity: _reduxEntity,
  pendingOperation: _pendingOperation,
  notificationActions: _notificationActions
}))));
TabsSection.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  checksArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired,
  followupsArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired,
  unanalyzedFollowupsCount: PropTypes.number.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    formType: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  path: PropTypes.string,
  formActions: PropTypes.shape({
    change: PropTypes.func.isRequired
  }),
  reduxEntity: PropTypes.string,
  pendingOperation: PropTypes.bool,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  })
};
export default TabsSection;